import React from 'react';
import { Box } from '@mui/material';

export default function BrandLogo({ size = 36 }) {
  return (
    <Box
      component="img"
      src="/logo192.png"
      alt="TrustX"
      sx={{
        width: size,
        height: size,
        borderRadius: 2,
        flexShrink: 0,
        objectFit: 'contain',
      }}
    />
  );
}
